import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Icon } from "@/lib/icons";

import { parseLocalDate } from "@/lib/dates";
const fmtDay = (s) => { const d = parseLocalDate(s); return d ? d.toLocaleDateString(undefined, { weekday: "short", month: "long", day: "numeric" }) : ""; };
const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "");

export default function MyVolunteering() {
  const [data, setData] = useState(undefined);
  useEffect(() => { api.get("/events/my-volunteering").then((r) => setData(r.data)).catch(() => setData({ items: [], total_roles: 0, total_hours: 0 })); }, []);

  if (data === undefined) return <div className="text-ink/60 py-8">Loading…</div>;

  return (
    <div data-testid="volunteering-page">
      <h1 className="font-zilla text-3xl font-semibold mb-1">Volunteering</h1>
      <p className="text-[16px] text-ink/70 mb-5">The volunteer roles you've claimed across Rosemoor events.</p>

      <div className="grid grid-cols-2 gap-3 mb-5">
        <div className="bg-cream border border-ink/15 rounded-xl p-4" data-testid="vol-total-roles">
          <Icon name="HandHeart" className="w-5 h-5 text-maroon mb-1" />
          <div className="text-[12px] uppercase tracking-wide text-ink/55 font-semibold">Roles claimed</div>
          <div className="font-zilla text-2xl font-semibold">{data.total_roles}</div>
        </div>
        <div className="bg-cream border border-ink/15 rounded-xl p-4" data-testid="vol-total-hours">
          <Icon name="Clock" className="w-5 h-5 text-maroon mb-1" />
          <div className="text-[12px] uppercase tracking-wide text-ink/55 font-semibold">Hours pledged</div>
          <div className="font-zilla text-2xl font-semibold">{data.total_hours}</div>
        </div>
      </div>

      <div className="bg-cream border border-ink/15 rounded-xl overflow-hidden" data-testid="volunteering-list">
        {data.items.length === 0 && (
          <div className="p-10 text-center text-ink/55" data-testid="volunteering-none">
            You haven't claimed any volunteer roles yet. Open Events to sign up for one.
          </div>
        )}
        {data.items.map((v) => (
          <div key={v.vh_id} data-testid={`vol-${v.vh_id}`} className="flex items-center gap-3 px-5 py-4 border-b border-ink/8 last:border-0">
            <div className="w-10 h-10 rounded-full bg-olive/15 flex items-center justify-center shrink-0">
              <Icon name="HandHeart" className="w-5 h-5 text-dark-olive" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-[16px] font-semibold flex items-center gap-2">{v.role_name}{v.points ? <span data-testid={`myvol-points-${v.vh_id}`} className="text-[11px] text-dark-olive bg-olive/15 rounded-full px-2 py-0.5 font-semibold">{v.points} pts</span> : null}</div>
              <div className="text-[13px] text-ink/55">{v.event_title}</div>
              <div className="text-[12px] text-ink/45">
                {fmtDay(v.start || v.at)}{v.start ? ` · ${fmtTime(v.start)}${v.end ? `–${fmtTime(v.end)}` : ""}` : ""}
              </div>
            </div>
            {v.hours ? <span className="text-[13px] px-2.5 py-1 rounded-full bg-gold/25 text-ink font-semibold shrink-0">{v.hours}h</span> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
